<div class="proficiency-bonus">
  <div class="label"
       [innerText]="'Proficiency Bonus'"
  ></div>
  <div class="value"
       [innerText]="bonus"
  ></div>
</div>
